import React from 'react'

import { Props } from './types'

const DEFAULT_HEIGHT = 8

const CustomTick: React.FC<Props> = (props) => {
	const { x, y, payload } = props
	const words = payload?.value?.split(' ') || []

	return (
		<g transform={`translate(${x},${y})`}>
			<text x={0} y={0} dy={16}>
				{words.map((word, index) => (
					<tspan textAnchor="middle" x="0" dy={DEFAULT_HEIGHT * (index + 1)}>
						{word}
					</tspan>
				))}
			</text>
		</g>
	)
}

export default CustomTick
